import React from "react";
import {
  Box,
  Breadcrumbs,
  Link,
  Paper,
  Stack,
  Typography,
  ChevronRightIcon,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

function handleClick(event) {
  event.preventDefault();
  console.info("You clicked a breadcrumb.");
}

const BasicBreadcrumb = () => {
  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      href="/"
      onClick={handleClick}
    >
      Link
    </Link>,
    <Link
      underline="hover"
      key="2"
      color="inherit"
      href="#"
      onClick={handleClick}
    >
      Link
    </Link>,
    <Typography key="3" color="text.primary">
      Link
    </Typography>,
  ];

  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Basic Breadcrumbs
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <Typography variant="body1" fontSize={14}>
            Basic breadcrumbs
          </Typography>
          <PreviewAndEditor
            language={"js"}
            value={
              '            <Breadcrumbs aria-label="breadcrumb">\n' +
              '              <Link underline="hover" color="inherit" href="/">\n' +
              "                Link\n" +
              "              </Link>\n" +
              '              <Link underline="hover" color="inherit" href="#">\n' +
              "                Link\n" +
              "              </Link>\n" +
              '              <Typography color="text.primary" variant="body1">\n' +
              "                Link\n" +
              "              </Typography>\n" +
              "            </Breadcrumbs>"
            }
          >
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" href="/">
                Link
              </Link>
              <Link underline="hover" color="inherit" href="#">
                Link
              </Link>
              <Typography color="text.primary" variant="body1">
                Link
              </Typography>
            </Breadcrumbs>
          </PreviewAndEditor>
        </Box>

        <Box mb={3}>
          <Typography variant="body1" fontSize={14}>
            Basic breadcrumbs with Custom separator
          </Typography>
          <PreviewAndEditor

            language={"js"}
            value={
              "  const breadcrumbs = [\n" +
              "    <Link\n" +
              '      underline="hover"\n' +
              '      key="1"\n' +
              '      color="inherit"\n' +
              '      href="/"\n' +
              "      onClick={handleClick}\n" +
              "    >\n" +
              "      Link\n" +
              "    </Link>,\n" +
              "    <Link\n" +
              '      underline="hover"\n' +
              '      key="2"\n' +
              '      color="inherit"\n' +
              '      href="#"\n' +
              "      onClick={handleClick}\n" +
              "    >\n" +
              "      Link\n" +
              "    </Link>,\n" +
              '    <Typography key="3" color="text.primary">\n' +
              "      Link\n" +
              "    </Typography>,\n" +
              "  ];\n <Breadcrumbs\n" +
              '                separator={<NavigateNextIcon fontSize="small" />}\n' +
              '                aria-label="breadcrumb"\n' +
              "              >\n" +
              "                {breadcrumbs}\n" +
              "              </Breadcrumbs>"
            }
          >
            <Stack spacing={2}>
              <Breadcrumbs
                separator={<ChevronRightIcon fontSize="small" />}
                aria-label="breadcrumb"
              >
                {breadcrumbs}
              </Breadcrumbs>
            </Stack>
          </PreviewAndEditor>
        </Box>

        <Box mb={3}>
          <Typography variant="body1" fontSize={14}>
            Basic breadcrumbs with Collapsed breadcrumbs
          </Typography>
          <PreviewAndEditor

            language={"js"}
            value={
              "  const breadcrumbs = [\n" +
              "    <Link\n" +
              '      underline="hover"\n' +
              '      key="1"\n' +
              '      color="inherit"\n' +
              '      href="/"\n' +
              "      onClick={handleClick}\n" +
              "    >\n" +
              "      Link\n" +
              "    </Link>,\n" +
              "    <Link\n" +
              '      underline="hover"\n' +
              '      key="2"\n' +
              '      color="inherit"\n' +
              '      href="#"\n' +
              "      onClick={handleClick}\n" +
              "    >\n" +
              "      Link\n" +
              "    </Link>,\n" +
              '    <Typography key="3" color="text.primary">\n' +
              "      Link\n" +
              "    </Typography>,\n" +
              "  ];\n " +
              "<Breadcrumbs\n" +
              '                  separator={<ChevronRightIcon fontSize="small" />}\n' +
              "                  maxItems={2}\n" +
              '                  aria-label="breadcrumb"\n' +
              "                >\n" +
              "                  {breadcrumbs}\n" +
              "                </Breadcrumbs>" +
              ""
            }
          >
            <Stack spacing={2}>
              <div role="presentation" onClick={handleClick}>
                <Breadcrumbs
                  separator={<ChevronRightIcon fontSize="small" />}
                  maxItems={2}
                  aria-label="breadcrumb"
                >
                  {breadcrumbs}
                </Breadcrumbs>
              </div>
            </Stack>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default BasicBreadcrumb;
